import(/* webpackMode: "eager", webpackExports: ["LeaderboardContent"] */ "/vercel/path0/app/leaderboard/components/LeaderboardContent.tsx");
